import { Box } from '@mantine/core';
import { Text } from '@huspy/briks-web';
import { ComponentProps } from 'react';
import { bankApplicationStatusMapper } from '@modules/opportunities/mappers/bankApplicationStatusMapper';
import {
  BankApplicationStatus,
  BankApplicationSubStatus,
  BankSubmissionChannelType,
} from '@modules/opportunities/entities/bankApplication/bankApplication.entity';
import {
  BANK_APPLICATION_STATUS,
  BANK_SUBMISSION_CHANNEL_TYPE,
} from '@modules/opportunities/entities/bankApplication/const';
import { useTranslation } from 'react-i18next';
import { bankApplicationStatusBadgeStyles } from '@components/BankApplicationStatusBadge/styles/index.css';

type BankApplicationStatusBadgeProps = {
  status: BankApplicationStatus;
  subStatus?: BankApplicationSubStatus;
  bankSubmissionChannelType?: BankSubmissionChannelType | null;
};

// eslint-disable-next-line max-len
const directBankTranslation = 'opportunity.caseSubmission.submitApplications.bankAndHuspySubmission.banksCard.sentThroughBank';

export const BankApplicationStatusBadge = ({
  status,
  subStatus,
  bankSubmissionChannelType,
  ...props
}: BankApplicationStatusBadgeProps & ComponentProps<typeof Box<'div'>>) => {
  const { t } = useTranslation();
  const statusValues = bankApplicationStatusMapper(status, subStatus);
  // eslint-disable-next-line max-len -- To ensure the condition is readable
  const text = (status !== BANK_APPLICATION_STATUS.draft && bankSubmissionChannelType === BANK_SUBMISSION_CHANNEL_TYPE.directBank)
    ? t(directBankTranslation)
    : statusValues.text;
  return (
    <Box
      className={ bankApplicationStatusBadgeStyles({ color: statusValues.color }) }
      { ...props }
    >
      <Text size='sm' weight='semiBold'>
        {text}
      </Text>
    </Box>
  );
};
